// MONEY-IA-2 — the query-preserving redirect target. The subscribe return url
// (/dashboard/billing/usage?subscribed=1) and the top-up return url
// (/dashboard/billing/wallet?topup=ok) redirect to the merged page, and their
// query strings MUST survive so the return parameters still work.

/** Append the current (or given) search string to a target path. */
export function withCurrentSearch(to: string, search: string = window.location.search): string {
  return `${to}${search}`
}
